
export default function Services() {
  const services = [
    {
      icon: 'ri-temp-cold-line',
      title: 'Air Conditioning',
      description: 'Stay cool in Florida\'s heat with our expert AC installation, repair, and maintenance services. We service all major brands and offer energy efficient solutions.',
      features: ['AC Installation', 'AC Repair', 'Maintenance Plans', 'Emergency Service'],
      image: 'https://public.readdy.ai/ai/img_res/545a3adb54687065564be774d361e780.jpg'
    },
    {
      icon: 'ri-fire-line',
      title: 'Heating',
      description: 'Keep your home comfortable during cooler months with our heating system installation, repair, and maintenance. Expert service for furnaces, heat pumps, and more.',
      features: ['Furnace Repair', 'Heat Pump Service', 'System Installation', 'Annual Inspections'],
      image: 'https://readdy.ai/api/search-image?query=Modern%20heating%20system%20and%20furnace%20installation%20in%20Florida%20home%2C%20professional%20technician%20inspecting%20heating%20unit%2C%20clean%20mechanical%20room%20with%20organized%20pipes%20and%20equipment%2C%20warm%20lighting%20showcasing%20quality%20heating%20service%20and%20maintenance&width=600&height=400&seq=service-heat-002&orientation=landscape'
    },
    {
      icon: 'ri-drop-line',
      title: 'Plumbing',
      description: 'From leaky faucets to complete repiping, our licensed plumbers handle all your plumbing needs. Fast, reliable service with upfront pricing and guaranteed workmanship.',
      features: ['Leak Repair', 'Drain Cleaning', 'Water Heaters', 'Pipe Installation'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20plumber%20repairing%20modern%20plumbing%20system%20in%20Florida%20home%2C%20clean%20bathroom%20or%20kitchen%20setting%2C%20plumber%20in%20uniform%20working%20on%20pipes%20and%20fixtures%2C%20organized%20tools%20and%20equipment%2C%20bright%20professional%20atmosphere%20showcasing%20quality%20plumbing%20service&width=600&height=400&seq=service-plumb-003&orientation=landscape'
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Water Quality',
      description: 'Ensure your family has clean, safe water with our water treatment solutions. We offer water softeners, filtration systems, and water testing services.',
      features: ['Water Softeners', 'Filtration Systems', 'Water Testing', 'Treatment Solutions'],
      image: 'https://readdy.ai/api/search-image?query=Modern%20water%20filtration%20and%20softener%20system%20installation%20in%20Florida%20home%2C%20clean%20utility%20room%20with%20professional%20water%20treatment%20equipment%2C%20clear%20water%20flowing%20from%20faucet%2C%20bright%20and%20clean%20setting%20showcasing%20water%20quality%20solutions%20and%20purification%20technology&width=600&height=400&seq=service-water-004&orientation=landscape'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Electrical',
      description: 'Safe, reliable electrical services for your home. Our licensed electricians handle everything from repairs to complete electrical panel upgrades and installations.',
      features: ['Electrical Repairs', 'Panel Upgrades', 'Lighting Installation', 'Safety Inspections'],
      image: 'https://readdy.ai/api/search-image?query=Licensed%20electrician%20working%20on%20modern%20electrical%20panel%20and%20wiring%20in%20Florida%20home%2C%20professional%20technician%20in%20uniform%20installing%20electrical%20components%2C%20organized%20electrical%20box%20with%20neat%20wiring%2C%20bright%20and%20safe%20working%20environment%20showcasing%20quality%20electrical%20service&width=600&height=400&seq=service-elec-005&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1B3A6B] mb-4">
            Complete Home Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Voltis provides comprehensive plumbing, heating, air conditioning, water quality, and electrical services throughout Florida. Our expert technicians are ready to help with all your home service needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group hover:-translate-y-2">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={`${service.title} services in Florida by Voltis`}
                  title={`Professional ${service.title} Services`}
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1B3A6B]/70 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-14 h-14 bg-[#B22234] rounded-full flex items-center justify-center shadow-lg">
                    <i className={`${service.icon} text-3xl text-white`}></i>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-2xl font-bold text-[#1B3A6B] mb-3">{service.title}</h3>
                <p className="text-sm text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-gray-700">
                      <i className="ri-check-line text-[#B22234] mr-2 text-lg"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                
                <a href="#contact" className="inline-flex items-center text-sm font-semibold text-[#1B3A6B] hover:text-[#B22234] transition-colors group/link whitespace-nowrap">
                  Learn More
                  <i className="ri-arrow-right-line ml-2 group-hover/link:translate-x-1 transition-transform"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-[#1B3A6B] rounded-2xl p-8 md:p-12 text-center shadow-xl">
          <h3 className="text-3xl font-bold text-white mb-4">
            Need Emergency Service?
          </h3>
          <p className="text-lg text-white/90 mb-6 max-w-2xl mx-auto">
            We're available 24/7 for emergency plumbing, heating, AC, and electrical services across Florida. Don't wait call us now!
          </p>
          <a href="tel:+18005551234" className="inline-flex items-center bg-[#B22234] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#8B1A29] transition-all shadow-lg hover:scale-105 whitespace-nowrap">
            <i className="ri-phone-fill mr-2"></i>
            Call (800) 555-1234
          </a>
        </div>
      </div>
    </section>
  );
}
